module.exports = __webpack_public_path__ + "images/attachmentce415d6e66c3a632d83b653718b1da46.png";